module.exports = __webpack_public_path__ + "img/example_5_icon.2e7b228c.png";